import { ThemeProvider as EmotionThemeProvider } from '@emotion/react';
import { ReactNode } from 'react';
import { THEME } from '@anytag/shared-constants';

interface ThemeProviderProps {
  children: ReactNode;
}
export const ThemeProvider = ({ children }: ThemeProviderProps) => (
  <EmotionThemeProvider theme={THEME}>{children}</EmotionThemeProvider>
);
